import { motion } from "framer-motion";
import { useEffect, useMemo, useState } from "react";
import { FiArrowLeft } from "react-icons/fi";
import { MdRadioButtonChecked, MdRadioButtonUnchecked } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import placeholder from "../assets/place.webp";
import { productAtom } from "../atoms/auth";
import ProductViewItem from "../components/ProductViewItem";
import { auth } from "../functions/firebase";
import UpdateCart from "./UpdateCart";

export default function ProductView() {

    const [product, setProduct] = useRecoilState(productAtom)
    const [loading, setLoading] = useState(false)

    const options_keys = ["options", "options1", "options2", "options3", "options4", "options5"]

    const [options, setOptions] = useState([])
    const [options1, setOptions1] = useState([])
    const [options2, setOptions2] = useState([])
    const [options3, setOptions3] = useState([])
    const [options4, setOptions4] = useState([])
    const [options5, setOptions5] = useState([])

    const setValues = {
        options: setOptions,
        options1: setOptions1,
        options2: setOptions2,
        options3: setOptions3,
        options4: setOptions4,
        options5: setOptions5
    }

    const check = useMemo(() => {
        const selection = [ 
            ...options, 
            ...options1, 
            ...options2, 
            ...options3, 
            ...options4,
            ...options5
        ]

        return {
            options,
            options1,
            options2,
            options3,
            options4,
            options5,
            optionsTotal: selection.map(item => Number(item.price)).reduce((a, b) => a + b, 0),
            sources: selection.map(item => item.title)
        }
        
    }, [options, options1, options2, options3,options4,options5])

    const navigate = useNavigate() 

    useEffect(() => {

        if(!auth?.currentUser) {
            navigate("/getting-started")
            return;
        } 
       
    }, [])

    return (
        <>
            <div id="product-wrapper" style={{ overflowY: "hidden", minHeight: "100vh" }} >
                <motion.div initial={{ y: 15, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.1, bounce: 0 }} style={{ backgroundColor: "var(--background)", overflowY: "auto" }}>
                    
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <img src={(product.images || [])[0]?.uri || placeholder} alt="" 
                            style={{
                                width: "100vw",
                                aspectRatio: 16/12,
                                borderRadius: 30,
                                objectFit: "cover"
                            }}
                        />
                    </div>
                    <motion.div whileTap={{ opacity: 0.7 }} transition={{ duration: 0.1 }}
                        onClick={() => window.history.back()}
                        style={{
                            position: "fixed",
                            top: 0
                        }}
                    >
                        <FiArrowLeft size={30} color="#FFF"
                            style={{
                                padding: 10,
                                backgroundColor: "#000",
                                borderRadius: 50,
                                margin: 10
                            }}
                        />
                    </motion.div>
                </motion.div> 
                <motion.div initial={{ y: 15, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.1, bounce: 0 }}>
                    <div style={{ width: '90%', margin: "15px auto", color: localStorage.getItem("theme") === "light" ? "#000" : "#fff"}}>
                    
                        <div className="row spaceBetween centerX">
                            
                            <div style={{ maxWidth: "70%" }}>
                                <h1 style={{ fontSize: 35 }}>R{Number(product.price) + check.optionsTotal}</h1>
                                <p>{product.description || product?.title}</p> 
                                {product.id === "04dfd7d4-8c52-4968-88d3-e1ddc2982352" && (
                                    <>
                                        <br/>
                                        <p>
                                            Please note extra-pap is R15 if ordered alone and R10 if ordered with steak or chicken
                                        </p>
                                    </>
                                )}
                            </div>
                            <div>
                                <p style={{ marginBottom: 10, color: "grey" }}>Quantity</p>
                                <select name="Quantity" title="Choose Quantity" id="cats" style={{ width: 80, margin: 0, backgroundColor: "var(--primary)", color: "#000", border: "none", borderRadius: 100, padding: "5px 7px" }} 
                                    value={product.quantity}
                                    onChange={e => setProduct(c => ({ ...c, quantity: Number(e.target.value)}))}
                                >
                                    {[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20].map(i => <option key={"quantity-" +i} value={i}>{i}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div style={{ gap: 20 }}>
                        {options_keys.map(key => (
                            product[key]?.length > 0 && (
                                <motion.div 
                                initial={{ y: 15, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.2, bounce: 0 }}
                                style={{  backgroundColor: "#FFF", color: "#000", width: "calc(100% - 20px)", padding: "20px 10px", borderRadius: 20, marginBottom: 10 }}
                                >
                                    <p style={{  fontSize: 20, fontWeight: "bold", color: "#000" }}>{product[key + "Label"]} ({product[key + "Limit"] || 1}{product[key + "Required" ? " Required" : ""]})</p>
                                    {product[key]?.map(item => (item.show) && (
                                        <div key={item.id} 
                                            className="row centerX spaceBetween"
                                            style={{ gap: 10, margin: "5px 0" }}
                                        onClick={() => {

                                            const selected = check[key]?.find(itm => itm.id === item.id);
        
                                            const multiSelect = Number(product[key + "Limit"] || "1") > 1
                                            const canSelect = check[key].length < Number(product[key + "Limit"] || "1") 


                                            if(multiSelect) {
 
                                                if(item.title.toLowerCase().indexOf("no ") === 0) {
                                                    setValues[key]([item])
                                                    return;
                                                }

                                                if(selected) {
                                                    setValues[key](check[key].filter(selection => selection.id !== item.id))
                                                    return;
                                                }

                                                if(canSelect) {
                                                    setValues[key]([ ...check[key].filter(itm => itm.title.toLowerCase().indexOf("no ") !== 0), item ])
                                                }
                                            } else {

                                                if(selected) {
                                                    setValues[key](check[key].filter(selection => selection.id !== item.id))
                                                    return
                                                }
                                                setValues[key]([item])
                                            }

                                        }}
                                    >
                                        <div className="row centerX" style={{ gap: 10 }}>
                                            {check[key].find(selection => selection.id === item.id) ? <MdRadioButtonChecked color="#000" size={25} /> : <MdRadioButtonUnchecked color="#000" size={25} />}
                                            <p style={{ color: "#000" }} >{item.title}</p>
                                        </div>
                                        {Number(item.price || "0") > 0 && (
                                            <p style={{ color: "#000" }}>+ R{item.price}</p>
                                        )}
                                    </div>
                                    ))}
    
                                </motion.div>
                            )
                        ))}
                    </div>

                    {/* <motion.div 
                        initial={{ y: 15, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.2, bounce: 0 }}
                        style={{  backgroundColor: "#FFF", width: "calc(100% - 20px)", padding: "20px 10px", borderRadius: 20 }}
                    >
                        <div className="row spaceBetween centerX sources">
                            <div>
                                <p style={{  fontSize: 20, fontWeight: "bold", color: "#000" }}>Choose Sources | Flavours</p>
                                <p style={{ color: "var(--primary)", fontSize: "medium" }}>{product.sources.join(", ")}</p>
                            </div>
                            <select name="Sources" title="Choose Sources" id="cats" style={{ width: 150, margin: 0, backgroundColor: "var(--background)", color: "var(--text)", border: "none", borderRadius: 100 }} multiple={multiSelect}
                                value={product.sources}
                                onChange={e => {

                                    let sel = []
                                    for (const itm of e.target.selectedOptions) {

                                        const i = itm.value

                                        sel = (["No Sources"].includes(i) || !multiSelect) ? [i] : product.sources.includes(i) ? product.sources.filter(a => a !== i) : [ ...product.sources, i].filter(a => a !== "No Sources")
                                    }
 
                                    setProduct(c => ({ ...c, sources: sel }))
                                }}
                            >
                                {sources.map(c => (
                                    <option value={c} key={c}>{c}</option>
                                ))}
                            </select>
                        </div>
                    </motion.div> */}

                    <div style={{ margin: 10, marginTop: 20 }}>
                        <label htmlFor="requests">Any Special Requests?</label>
                        <input 
                            id="requests"
                            placeholder="Speacial Instructions"
                            value={product?.note}
                            onChange={el => setProduct(c => ({ ...c, note: el.target.value }))}
                            style={{ marginTop: 10 }}
                        />
                    </div>
                    
                    {window.innerWidth < 480 && <div style={{ height: 90, width: 20 }} />}
                    <ProductViewItem  check={check} optionsTotal={check.optionsTotal} setLoading={setLoading} />
                </motion.div>
            </div>
            {loading && <UpdateCart />}
        </>
    )
}

//